<template>
  <div class="wrapper">
    <!-- 标题区域 -->
    <div class="page-header">
      <div class="header-content">
        <h2 class="page-title">
          <i class="el-icon-s-order title-icon"></i>
          {{ $route.meta.name }}
        </h2>
        <div class="header-stats">
          <div class="stat-item">
            <span class="stat-label">总记录数</span>
            <span class="stat-value">{{ total }}</span>
          </div>
        </div>
      </div>
    </div>
    
    <!-- 搜索区域 -->
    <el-card class="search-card" shadow="never">
      <div class="card-header-title">
        <i class="el-icon-search"></i>
        <span>筛选条件</span>
      </div>
      <div class="header-search">
        <el-form ref="form" inline :model="searchData" label-width="100px">
          <el-form-item label="关键字">
            <el-input
              placeholder="请输入"
              v-model="searchData.keywordsValue"
              clearable
              class="input-with-select"
              size="small"
            >
              <el-select
                v-model="searchData.keywordsName"
                slot="prepend"
                placeholder="请选择"
                size="small"
              >
                <el-option
                  v-for="item in searchTypeFinanceOrderList"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-input>
          </el-form-item>
          <el-form-item label=" " label-width="50px">
            <el-button
              type="primary"
              size="small"
              icon="el-icon-search"
              @click="search"
              class="search-btn"
            >
              搜索
            </el-button>
            <el-button
              type="info"
              size="small"
              icon="el-icon-refresh"
              @click="reset"
              class="reset-btn"
            >
              重置
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>

    <!-- 表格区域 -->
    <el-card class="table-card" shadow="never">
      <div class="card-header-title">
        <i class="el-icon-s-grid"></i>
        <span>订单列表</span>
      </div>
      <tp-table
        :isNeedSerialNumber="true"
        :tableData="list"
        :columns="columns"
        :totalNum="total"
        :current-page.sync="currentPage"
        :pageSize.sync="pageSize"
      />
    </el-card>

    <!-- 线下还款 -->
    <OfflinePay
      v-if="dialogType == 'offlinePay'"
      ref="offlinePay"
      :orderNo="orderNo"
      @update="getList"
    />

    <!-- 设备监管 -->
    <el-dialog title="设备监管" :visible.sync="show_lock" width="800px" class="lock-dialog">
      <el-form ref="formLock" :model="lockData" label-width="130px">
        <div class="lock-info">
          <span>订单号：{{ lockData.orderNo }}</span>
          <span>客户姓名：{{ lockData.memberName }}</span>
          <span>手机号：{{ lockData.memberMobile }}</span>
        </div>
        <el-form-item label="上次上锁日：">{{ lockData.beforeLockDate || '-' }}</el-form-item>
        <el-form-item label="设备状态：">
          <el-select
            style="width: 220px"
            v-model="lockData.lockStatus"
            placeholder="请选择"
            clearable
            size="small"
          >
            <el-option label="未上锁" :value="0"></el-option>
            <el-option label="待上锁" :value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="lockData.lockStatus == 1" label="待上锁日期：">
          <el-date-picker
            style="width: 220px"
            v-model="lockData.lockDate"
            value-format="yyyy-MM-dd"
            size="small"
            type="date"
            placeholder="选择日期"
            :picker-options="pickerOptions"
          />
          <span class="tip-text">（ 注意：只能选当天及以后日期 ）</span>
        </el-form-item>
        <el-form-item v-if="lockData.lockStatus == 1" label="延期上锁服务费：">
          <el-input-number
            style="width: 220px"
            v-model="lockData.lockFee"
            size="small"
            :controls="false"
            :min="0.01"
          />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="show_lock = false" size="small">取 消</el-button>
        <el-button type="primary" @click="submitLock" size="small">提 交</el-button>
      </div>
    </el-dialog>

    <!-- 订单充账 -->
    <el-dialog title="订单充账" :visible.sync="show_balance" width="900px">
      <el-form
        ref="formBalance"
        :model="balanceData"
        label-width="140px"
        :rules="balanceRules"
      >
        <el-form-item label="订单号：">
          <span>{{ balanceData.orderNo }}</span>
        </el-form-item>
        <el-form-item label="客户姓名：">
          <span>{{ balanceData.memberName }}</span>
        </el-form-item>
        <el-form-item label="手机号：">
          <span>{{ balanceData.memberMobile }}</span>
        </el-form-item>
        <el-form-item label="充账余额：">
          <span>{{ balanceData.balanceAmount || "0.00" }} 元</span>
        </el-form-item>
        <el-form-item label="操作类型：" prop="actionType">
          <el-select
            v-model="balanceData.actionType"
            placeholder="请选择操作类型"
            style="width: 220px"
          >
            <el-option
              v-for="item in actionTypeOptions"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="本次调整金额：" prop="amount">
          <div style="display: flex; align-items: center; width: 220px;">
            <el-input-number
              v-model="balanceData.amount"
              placeholder="请输入调整金额"
              style="flex: 1;"
              :precision="2"
              :min="0.01"
              :controls="false"
            />
            <span style="margin-left: 8px; color: #909399">元</span>
          </div>
        </el-form-item>
        <el-form-item label="备注：">
          <el-input
            v-model="balanceData.remark"
            type="textarea"
            placeholder="请输入备注信息（选填）"
            :rows="3"
            style="width: 100%"
          ></el-input>
        </el-form-item>
      </el-form>

      <div slot="footer">
        <el-button @click="show_balance = false" size="small">取 消</el-button>
        <el-button type="primary" @click="submitBalance" size="small">提 交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { authBtnMixin } from "@/mixins/authBtnMixin";
import { searchTypeFinanceOrderList } from "@/enum/dict/index.js";
import { getFinanceOrderListAPI, submitLockAPI, addBalanceAPI } from "./api";
import OfflinePay from "./offline-pay.vue";

const columns = [
  {
    label: "客户信息",
    prop: "member",
    minWidth: "200",
    customRender(h, row) {
      return (
        <div>
          <div class="info-item">
            <span class="label">姓名：</span>
            <span class="value">{row["member"]?.["memberName"] || '-'}</span>
          </div>
          <div class="info-item">
            <span class="label">手机号：</span>
            <span class="value">{row["member"]?.["mobile"] || '-'}</span>
          </div>
        </div>
      );
    },
  },
  {
    label: "订单信息",
    prop: "orderInfo",
    minWidth: "260",
    customRender(h, row) {
      return (
        <div>
          <div class="info-item">
            <span class="label">订单号：</span>
            <span class="value">{row["orderNo"] || '-'}</span>
          </div>
          <div class="info-item">
            <span class="label">订单状态：</span>
            <el-tag size="mini" type="info">{row["statusName"] || '-'}</el-tag>
          </div>
          <div class="info-item">
            <span class="label">下单时间：</span>
            <span class="value">{row["createTime"] || '-'}</span>
          </div>
        </div>
      );
    },
  },
  {
    label: "审核",
    prop: "reviewUserName",
    minWidth: "120",
    customRender(h, row) {
      return <p class="table-cell-text">{row["reviewUser"]?.["userName"] || '-'}</p>;
    },
  },
  {
    label: "设备监管",
    prop: "device",
    minWidth: "200",
    customRender(h, row) {
      return (
        <div>
          <div class="info-item">
            <span class="label">设备锁状态：</span>
            <el-tag v-show={row["lockStatus"] == 0} type="success" size="mini">未上锁</el-tag>
            <el-tag v-show={row["lockStatus"] == 1} type="warning" size="mini">待上锁</el-tag>
            <el-tag v-show={row["lockStatus"] == 2} type="danger" size="mini">已上锁</el-tag>
          </div>
          <div class="info-item">
            <span class="label">待上锁日期：</span>
            <span class="value">{row["lockDate"] || "无"}</span>
          </div>
        </div>
      );
    },
  },
  {
    label: "成本",
    prop: "costPrice",
    minWidth: "120",
    customRender(h, row) {
      return <p class="table-cell-text amount-value">{row["costPrice"] || '-'}</p>;
    },
  },
  {
    label: "充账余额",
    prop: "balanceAmount",
    minWidth: 100,
    customRender(h, row) {
      return <p class="table-cell-text amount-value">{row["balanceAmount"] || "0.00"}</p>;
    },
  },
  {
    label: "操作",
    minWidth: "220",
    fixed: "right",
    customRender(h, row) {
      return (
        <div class="action-links">
          <el-link
              disabled={!this.isShowBtn(this.AUTH_BTN.finance_order_list_order_balance)}
              underline={false}
              type="primary"
              onClick={() => this.handleBalance(row)}
              class="action-link"
          >
            订单充账
          </el-link>

          <el-link
            disabled={!this.isShowBtn(this.AUTH_BTN.finance_order_list_offline_pay)}
            underline={false}
            type="primary"
            onClick={() => this.handleShowDialog("offlinePay", row["orderNo"])}
            class="action-link"
          >
            线下还款
          </el-link>

          <el-link
            v-show={row.status == 6 || row.status == 7}
            disabled={!this.isShowBtn(this.AUTH_BTN.finance_order_list_device_lock)}
            underline={false}
            type="primary"
            onClick={() => this.handleLock(row)}
            class="action-link"
          >
            设备监管
          </el-link>
        </div>
      );
    },
  },
];

export default {
  name: "FinanceOrderList",
  mixins: [authBtnMixin],
  components: { OfflinePay },
  data() {
    return {
      searchTypeFinanceOrderList,
      columns,
      currentPage: 1,
      pageSize: 10,
      total: 0,
      list: [],
      searchData: {
        keywordsName: "",
        keywordsValue: "",
      },
      dialogType: "",
      orderNo: "",
      // 设备监管
      lockData: {
        orderNo: "",
        memberName: "",
        memberMobile: "",
        lockStatus: 0,
        beforeLockDate: "",
        lockDate: "",
        lockFee: undefined,
      },
      show_lock: false,
      pickerOptions: {
        disabledDate(time) {
          const date = new Date();
          date.setTime(date.getTime() - 3600 * 1000 * 24);
          return time.getTime() < date;
        },
      },
      // 订单充账
      balanceData: {
        orderNo: "",
        memberName: "",
        memberMobile: "",
        balanceAmount: "",
        actionType: "",
        amount: "",
        remark: "",
      },
      show_balance: false,
      balanceRules: {
        actionType: [
          { required: true, message: "请选择操作类型", trigger: "change" },
        ],
        amount: [
          { required: true, message: "请输入调整金额", trigger: "blur" },
          {
            type: "number",
            min: 0.01,
            message: "调整金额必须大于0",
            trigger: "blur",
          },
        ],
      },
      actionTypeOptions: [
        { name: "增加余额", value: 101 },
        { name: "减少余额", value: 201 },
      ],
    };
  },
  provide() {
    return {
      context: this,
    };
  },
  mounted() {
    this.getList();
  },
  watch: {
    currentPage() {
      this.getList();
    },
    pageSize() {
      this.getList();
    },
  },
  methods: {
    // 设备监管
    handleLock(row) {
      this.lockData = {
        orderNo: row.orderNo,
        memberName: row.member.memberName,
        memberMobile: row.member.mobile,
        lockStatus: 1,
        beforeLockDate: row.lockDate,
        lockDate: '',
        lockFee: undefined,
      };
      this.show_lock = true;
    },
    // 提交设备监管
    submitLock() {
      const { orderNo, lockStatus, lockDate, lockFee } = this.lockData;
      let data = {};
      if (lockStatus == 1) {
        if (!lockDate) return this.$message.error("请选择待上锁日期！");
        if (!lockFee) return this.$message.error("请填写延期上锁服务费！");
        data = { orderNo, lockStatus, lockDate, lockFee };
      } else {
        data = { orderNo, lockStatus };
      }
      submitLockAPI(data).then(() => {
        this.$message.success("操作成功");
        this.getList();
        this.show_lock = false;
      });
    },
    search() {
      this.getList();
    },
    async getList() {
      const { keywordsName, keywordsValue } = this.searchData;
      if (!keywordsName && keywordsValue) return this.$message.error("请选择搜索类型！");
      let params = { page: this.currentPage, pageSize: this.pageSize };
      if (keywordsName) params[keywordsName] = keywordsValue;
      const res = await getFinanceOrderListAPI(params);
      this.list = res.list || [];
      this.total = res.total || 0;
    },
    reset() {
      Object.assign(this._data.searchData, this.$options.data().searchData);
      this.getList();
    },
    handleShowDialog(type, orderNo) {
      this.dialogType = type;
      this.orderNo = orderNo;
      this.$nextTick(() => {
        this.$refs[this.dialogType].outerVisible = true;
        if (type == "offlinePay") {
          this.$refs[this.dialogType].cashAmount = "";
          this.$refs[this.dialogType].balanceAmount = "";
        }
        this.$refs[this.dialogType].getOrderBillList();
      });
    },
    handleBalance(row) {
      this.balanceData = {
        orderNo: row.orderNo,
        memberName: row.member.memberName,
        memberMobile: row.member.mobile,
        balanceAmount: row.balanceAmount || "0.00",
        actionType: 101,
        amount: undefined,
        remark: "",
      };
      this.show_balance = true;
      // 清除表单验证状态
      this.$nextTick(() => {
        if (this.$refs.formBalance) {
          this.$refs.formBalance.clearValidate();
        }
      });
    },
    // 提交充账
    submitBalance() {
      this.$refs.formBalance.validate((valid) => {
        if (valid) {
          const { orderNo, actionType, amount, remark } = this.balanceData;
          const data = {
            orderNo,
            actionType,
            amount: amount.toString(),
            remark: remark || "",
          };

          addBalanceAPI(data)
              .then(() => {
                this.$message.success("充账操作成功");
                this.show_balance = false;
                this.getList();
              })
              .catch((error) => {
                console.error("充账操作失败:", error);
              });
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  width: 100%;
  background: linear-gradient(180deg, #f0f2f5 0%, #fafbfc 50%, #ffffff 100%);
  padding: 20px;
  min-height: calc(100vh - 84px);
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 200px;
    background: linear-gradient(135deg, rgba(64, 158, 255, 0.05) 0%, rgba(102, 177, 255, 0.02) 100%);
    pointer-events: none;
    z-index: 0;
  }
}

// 页面标题区域
.page-header {
  margin-bottom: 20px;
  position: relative;
  z-index: 1;
  
  .header-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 24px;
    background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
    border-radius: 16px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04), 0 8px 24px rgba(0, 0, 0, 0.06);
    border: 1px solid rgba(255, 255, 255, 0.8);
    backdrop-filter: blur(10px);
  }
  
  .page-title {
    margin: 0;
    font-size: 20px;
    font-weight: 700;
    color: #1a1e25;
    display: flex;
    align-items: center;
    gap: 12px;
    letter-spacing: -0.5px;
    
    .title-icon {
      font-size: 24px;
      background: linear-gradient(135deg, #409EFF 0%, #66b1ff 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
    }
  }
  
  .header-stats {
    display: flex;
    gap: 24px;
    
    .stat-item {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 8px;
      padding: 4px 14px;
      background: linear-gradient(135deg, #f0f7ff 0%, #e6f2ff 100%);
      border-radius: 10px;
      border: 1px solid rgba(64, 158, 255, 0.15);
      
      .stat-label {
        font-size: 12px;
        color: #909399;
        margin-right: 8px;
      }
      
      .stat-value {
        font-size: 16px;
        font-weight: 700;
        color: #409EFF;
        line-height: 1;
      }
    }
  }
}

// 卡片标题样式
.card-header-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 20px;
  padding-bottom: 12px;
  border-bottom: 2px solid #f0f2f5;
  
  i {
    font-size: 18px;
    color: #409EFF;
  }
}

// 搜索卡片样式
.search-card {
  margin-bottom: 20px;
  border-radius: 16px;
  border: none;
  background: #ffffff;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06), 0 1px 4px rgba(0, 0, 0, 0.04);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  z-index: 1;
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
    background: linear-gradient(90deg, #409EFF 0%, #66b1ff 50%, #85c1ff 100%);
  }

  &:hover {
    box-shadow: 0 8px 28px rgba(0, 0, 0, 0.1), 0 2px 8px rgba(0, 0, 0, 0.06);
    transform: translateY(-2px);
  }

  ::v-deep .el-card__body {
    padding: 24px 28px;
  }

  .header-search {
    .el-form {
      .el-form-item {
        margin-right: 15px;
        margin-bottom: 10px;
        
        .el-form-item__label {
          color: #303133;
          font-weight: 600;
          letter-spacing: 0.3px;
          font-size: 14px;
          position: relative;
          
          &::after {
            content: ':';
            margin-left: 2px;
            color: #909399;
          }
        }
        
        .el-input {
          width: 350px;
          
          .el-input__inner {
            border-radius: 10px;
            height: 38px;
            line-height: 38px;
            border: 1.5px solid #E4E7ED;
            transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
            background: #fafbfc;
            font-size: 13px;

            &:hover {
              border-color: #C0C4CC;
              background: #ffffff;
            }
          }
          
          &.is-active .el-input__inner,
          .el-input__inner:focus {
            border-color: #409EFF;
            box-shadow: 0 0 0 3px rgba(64, 158, 255, 0.15);
            background: #ffffff;
          }
        }
        
        .el-select .el-input {
          width: 100px;
        }
        
        .input-with-select {
          vertical-align: middle;
          
          .el-input-group__prepend {
            background-color: #fff;
            border-radius: 10px 0 0 10px;
          }
          
          .el-input__inner {
            border-radius: 0 10px 10px 0;
          }
        }
      }
      
      .search-btn {
        border-radius: 10px;
        padding: 10px 24px;
        font-weight: 600;
        font-size: 13px;
        background: linear-gradient(135deg, #66b1ff 0%, #409EFF 100%);
        border: none;
        box-shadow: 0 4px 14px rgba(64, 158, 255, 0.35), 0 2px 6px rgba(64, 158, 255, 0.2);
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        letter-spacing: 0.3px;

        &:hover {
          background: linear-gradient(135deg, #409EFF 0%, #337ecc 100%);
          box-shadow: 0 6px 20px rgba(64, 158, 255, 0.45), 0 3px 8px rgba(64, 158, 255, 0.25);
          transform: translateY(-2px);
        }

        &:active {
          transform: translateY(0);
          box-shadow: 0 2px 8px rgba(64, 158, 255, 0.3);
        }
      }

      .reset-btn {
        border-radius: 10px;
        padding: 10px 24px;
        font-weight: 600;
        font-size: 13px;
        background: linear-gradient(135deg, #a4a9b0 0%, #909399 100%);
        border: none;
        box-shadow: 0 4px 12px rgba(144, 147, 153, 0.25);
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        letter-spacing: 0.3px;

        &:hover {
          background: linear-gradient(135deg, #909399 0%, #82848a 100%);
          box-shadow: 0 6px 16px rgba(144, 147, 153, 0.35);
          transform: translateY(-2px);
        }

        &:active {
          transform: translateY(0);
          box-shadow: 0 2px 8px rgba(144, 147, 153, 0.25);
        }
      }
    }
  }
}

// 表格卡片样式
.table-card {
  border-radius: 16px;
  border: none;
  background: #ffffff;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06), 0 1px 4px rgba(0, 0, 0, 0.04);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  z-index: 1;
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
    background: linear-gradient(90deg, #67C23A 0%, #85ce61 50%, #95d475 100%);
  }

  &:hover {
    box-shadow: 0 8px 28px rgba(0, 0, 0, 0.1), 0 2px 8px rgba(0, 0, 0, 0.06);
    transform: translateY(-2px);
  }

  ::v-deep .el-card__body {
    padding: 24px;
  }

  ::v-deep .tp-table {
    .el-table {
      border-radius: 12px;
      overflow: hidden;
      border: 1px solid #EBEEF5;
      background: #ffffff;

      th {
        background: linear-gradient(180deg, #F8FAFF 0%, #F0F4FF 100%);
        color: #303133;
        font-weight: 700;
        padding: 18px 0;
        border-bottom: 2px solid #E4E7ED;
        letter-spacing: 0.3px;
        text-transform: uppercase;
        font-size: 12px;
        
        &:first-child {
          padding-left: 20px;
        }
      }

      tbody {
        tr {
          transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
          border-bottom: 1px solid #F0F2F5;

          &:hover > td {
            background: linear-gradient(90deg, #F5F7FA 0%, #FAFBFC 100%) !important;
          }
          
          &:last-child {
            border-bottom: none;
          }

          td {
            padding: 18px 0;
            border-bottom: 1px solid #F5F7FA;
            
            &:first-child {
              padding-left: 20px;
            }
            
            .info-item {
              display: flex;
              align-items: center;
              margin-bottom: 8px;
              line-height: 1.5;
              
              &:last-child {
                margin-bottom: 0;
              }
              
              .label {
                color: #909399;
                font-size: 13px;
                min-width: 80px;
                flex-shrink: 0;
              }
              
              .value {
                color: #303133;
                font-weight: 500;
                word-break: break-all;
              }
            }
            
            .table-cell-text {
              margin: 0;
              color: #606266;
              font-size: 13px;
              line-height: 1.8;
              font-weight: 400;
            }
            
            .amount-value {
              color: #303133;
              font-weight: 600;
              font-size: 14px;
            }
            
            .action-links {
              display: flex;
              flex-wrap: wrap;
              gap: 8px;
              
              .action-link {
                font-weight: 500;
                transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
                
                &:hover:not(.is-disabled) {
                  transform: translateY(-1px);
                  color: #66b1ff;
                }
                
                &.is-disabled {
                  opacity: 0.5;
                  cursor: not-allowed;
                }
              }
            }
          }
        }
      }
    }
    
    .el-table__fixed-right {
      height: 100% !important;
    }

    .pagination {
      margin-top: 24px;
      padding: 20px 0 0;
      border-top: 2px solid #F0F2F5;
      
      ::v-deep .el-pagination {
        .el-pagination__total {
          color: #606266;
          font-weight: 500;
        }
        
        .btn-prev,
        .btn-next {
          border-radius: 6px;
          transition: all 0.3s ease;
          
          &:hover {
            background: #F5F7FA;
            color: #409EFF;
          }
        }
        
        .el-pager li {
          border-radius: 6px;
          transition: all 0.3s ease;
          
          &:hover {
            color: #409EFF;
            background: #F5F7FA;
          }
          
          &.active {
            background: linear-gradient(135deg, #66b1ff 0%, #409EFF 100%);
            color: #ffffff;
            font-weight: 600;
            box-shadow: 0 2px 6px rgba(64, 158, 255, 0.3);
          }
        }
        
        .el-select .el-input__inner {
          border-radius: 6px;
          border-color: #DCDFE6;
          
          &:hover {
            border-color: #C0C4CC;
          }
        }
        
        .el-input__inner {
          border-radius: 6px;
          border-color: #DCDFE6;
          
          &:hover {
            border-color: #C0C4CC;
          }
          
          &:focus {
            border-color: #409EFF;
            box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.15);
          }
        }
      }
    }
  }
}

// 对话框样式
::v-deep .lock-dialog {
  .el-dialog {
    border-radius: 12px;
    
    .el-dialog__header {
      padding: 20px 24px;
      background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
      border-bottom: 2px solid #f0f2f5;
      
      .el-dialog__title {
        font-size: 18px;
        font-weight: 700;
        color: #1a1e25;
      }
    }
    
    .el-dialog__body {
      padding: 24px;
      
      .lock-info {
        font-size: 15px;
        font-weight: 600;
        margin-bottom: 24px;
        padding: 16px;
        background: linear-gradient(135deg, #f0f7ff 0%, #e6f2ff 100%);
        border-radius: 8px;
        border: 1px solid rgba(64, 158, 255, 0.15);
        display: flex;
        flex-wrap: wrap;
        gap: 20px;
        
        > span {
          color: #303133;
        }
      }
      
      .el-form-item {
        margin-bottom: 20px;
        
        .el-form-item__label {
          color: #303133;
          font-weight: 600;
        }
        
        .el-select,
        .el-date-editor,
        .el-input-number {
          .el-input__inner {
            border-radius: 8px;
            border: 1.5px solid #E4E7ED;
            transition: all 0.3s ease;
            
            &:hover {
              border-color: #C0C4CC;
            }
            
            &:focus {
              border-color: #409EFF;
              box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.15);
            }
          }
        }
      }
      
      .tip-text {
        color: #f56c6c;
        font-size: 13px;
        margin-left: 15px;
      }
    }
    
    .el-dialog__footer {
      padding: 16px 24px;
      background: #fafbfc;
      border-top: 1px solid #f0f2f5;
      
      .el-button {
        border-radius: 8px;
        padding: 10px 20px;
        font-weight: 500;
        transition: all 0.3s ease;
        
        &:hover {
          transform: translateY(-1px);
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        }
        
        &.el-button--primary {
          background: linear-gradient(135deg, #66b1ff 0%, #409EFF 100%);
          border: none;
          box-shadow: 0 2px 8px rgba(64, 158, 255, 0.3);
          
          &:hover {
            background: linear-gradient(135deg, #409EFF 0%, #337ecc 100%);
            box-shadow: 0 4px 12px rgba(64, 158, 255, 0.4);
          }
        }
      }
    }
  }
}

// 响应式设计
@media (max-width: 1400px) {
  .search-card .header-search .el-form ::v-deep {
    .el-form-item {
      margin-right: 12px;
    }
  }
  
  .page-header .header-content {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
    
    .header-stats {
      width: 100%;
      justify-content: flex-start;
    }
  }
}

@media (max-width: 768px) {
  .wrapper {
    padding: 12px;
  }
  
  .page-header .header-content {
    padding: 16px;
    
    .page-title {
      font-size: 20px;
    }
  }
  
  .search-card,
  .table-card {
    border-radius: 12px;
    
    ::v-deep .el-card__body {
      padding: 16px;
    }
  }
  
  .search-card .header-search .el-form {
    .el-form-item {
      .el-input {
        width: 100% !important;
      }
    }
  }
}
</style>
